import firebase from "../firebase";
import { DbUser } from "@/database/DbUser";

/** tsv フォーマットは、固定ではない おかしな仕様なため
 *  それぞれの項目を解析してDBに取り込める形式に変換する
 *
 */
export default class TsvUtil {
    // EXCELからコピペされたテキスト
    private static excelText: string;

    // Header
    private static headerData: string[];

    // 取り込み後の データ tsv
    private static tsv: string;

    // 必須ヘッダー 気持ち悪いが 日本語 キー の連想配列
    private static MANDATORY_HEADERS = {
        applicationNumber: "申込番号",
        ainderGarten: "園（名称）",
        prefectures: "園（都道府県）",
        municipality: "園（市区町村）",
        name: "氏名（漢字）",
        nameFurigana: "氏名（ふりがな）",
        birthday: "生年月日",
        email: "メールアドレス"
    };

    // 各項目のindexを保持する
    private static headerIndex = {
        // 申込番号
        applicationNumber: -1,
        // 園（名称）
        ainderGarten: -1,
        // 園（都道府県）
        prefectures: -1,
        // 園（市区町村）
        municipality: -1,
        // 氏名（漢字）
        name: -1,
        // 氏名（ふりがな）
        nameFurigana: -1,
        // 生年月日
        birthday: -1,
        // メールアドレス
        email: -1
    };

    // 講義・分科会等N（{名称}）：申込 10列
    private static lecturesSubcommitteesHeaderIndex: number[] = [];
    private static lecturesSubcommittees: string[] = [];

    public static parse(excelText: string): Promise<DbUser[]> {
        /*
        申込番号、園（名称）、園（都道府県）、園（市区町村）、氏名（漢字）、氏名（ふりがな）、生年月日、メールアドレスは必須項目
        　申込番号、氏名（漢字）、氏名（ふりなが）、生年月日、メールアドレスは値入力も必須
        　園（名称）、園（都道府県）、園（市区町村）の値は空白でも可

        「講義・分科会等N（{名称}）：申込」（N=1, 2, …）が一つ以上ある場合、“○” の者に対して分科会番号Nの章を受講登録する
        「講義・分科会等N（{名称}）：申込」が一つもない場合、全員に対して全ての章を受講登録する
        講義・分科会等Nの{名称}は履歴連携CSV出力で使用するため、保存しておく
        */
        this.excelText = excelText;
        let i = 0;
        const users: DbUser[] = [];
        this.lecturesSubcommittees = [];
        this.lecturesSubcommitteesHeaderIndex = [];

        return new Promise((resolve, reject) => {
            console.log("parse");
            const rows = this.excelText.split("\n");
            rows.forEach((row) => {
                // タブ毎に分割
                const data = row.split("\t");
                if (data.length == 1) return;
                if (i == 0){
                    // 1行目を調べる
                    this.parseHeader(data);
                }
                else {
                    // 2行目 以降はデータ
                    const u: DbUser | null = this.parseData(data);
                    console.log('u', u);
                    if (u != null) {
                        users.push(u);
                    }
                }
                i++;
            });
            // 取り込み後のデータ tsv 生成
            this.createTsv(users);

            resolve(users);
        });
    }

    // ヘッダーのインデックスを取得する
    private static parseHeader(data: string[]){
        this.headerData = data.slice(0, data.length);
        console.log('headerData', this.headerData);
        const keys = Object.keys(this.MANDATORY_HEADERS);
        const values = Object.values(this.MANDATORY_HEADERS);
        data.forEach((t, tsvIndex) => {
            if (t == "") return;
            keys.forEach((h, headerIndex) => {
                const v = values[headerIndex];
                if (t == v){
                    const fnc = `(self) => { self.headerIndex.${h} = ${tsvIndex} }`;
                    eval(fnc)(this);
                }
            });

            if ((t.indexOf('講義・分科会等') != -1) && (t.indexOf('申込') != -1) ){
                // 講義・分科会等N（{名称}）：申込 最大10件
                this.lecturesSubcommittees.push(t);
                this.lecturesSubcommitteesHeaderIndex.push(tsvIndex);
            }
        });
        console.log('lecturesSubcommitteesHeaderIndex', this.lecturesSubcommitteesHeaderIndex);
    }

    // データを DbUser に変換
    private static parseData(data: string[]): DbUser | null {
        const result = new DbUser();
        // 必須項目があるかチェック
        if ( (this.headerIndex.applicationNumber == -1)
                || (this.headerIndex.name == -1)
                || (this.headerIndex.nameFurigana == -1)
                || (this.headerIndex.birthday == -1)
                || (this.headerIndex.email == -1) ) {
            return null;
        }
        result.applicationNumber = parseInt(data[ this.headerIndex.applicationNumber ]);
        result.name              = data[ this.headerIndex.name ];
        result.nameFurigana      = data[ this.headerIndex.nameFurigana ];
        result.birthday          = data[ this.headerIndex.birthday ];
        result.email             = data[ this.headerIndex.email ];
        // 必須ではない項目
        if ( this.headerIndex.ainderGarten != -1) {
            result.ainderGarten = data[ this.headerIndex.ainderGarten ];
        }
        if ( this.headerIndex.prefectures != -1) {
            result.prefectures = data[ this.headerIndex.prefectures ];
        }
        if ( this.headerIndex.municipality != -1) {
            result.municipality = data[ this.headerIndex.municipality ];
        }

        // 講義・分科会等N（{名称}）：申込
        result.lecturesSubcommittees = this.lecturesSubcommittees;
        result.applicationLecturesSubcommittees = [];
        this.lecturesSubcommitteesHeaderIndex.forEach((i) => {
            console.log("lecturesSubcommitteesHeaderIndex", i, data[i], this.headerData[i]);
            if (data[i] == '〇'){
                // 講義・分科会等N 分科会番号 を抽出
                const tmp = this.headerData[i].match(/講義・分科会等([1-9]+)/);
                const applicationNumber = tmp![1];
                result.applicationLecturesSubcommittees.push( applicationNumber );
            }
        });
        return result;
    }

    private static createTsv(users: DbUser[]) {
        this.tsv = "申込番号\t園（名称）\t園（都道府県）\t園（市区町村）\t氏名（漢字）\t氏名（ふりがな）\t生年月日\tメールアドレス\n";
        users.forEach((user) => {
            console.log("user", user);
            this.tsv += `${user.applicationNumber}\t${user.ainderGarten}\t${user.prefectures}\t${user.municipality}\t${user.name}\t${user.nameFurigana}\t${user.birthday}\t${user.email}\n`;
        });
    }

    public static getTsv(): string {
        return this.tsv;
    }
}